<template>
  <div class="editTranslate">
    <el-checkbox
      v-model="checked"
      :true-label="1"
      :false-label="0"
      class="check-box"
      >开启翻译替换?</el-checkbox
    >

    <i
      class="el-icon-sort-down"
      @click="choiceType"
      :class="!choice ? 'blue' : ''"
    >
    </i>
    <i
      class="el-icon-sort-up"
      @click="choiceType"
      :class="choice ? 'blue' : ''"
    ></i>
    <span @click="getTranslate" v-show="!choice" v-preventReClick>中译英</span>
    <span @click="getTranslate" v-show="choice" v-preventReClick>英译中</span>

    <div class="hint" v-show="isShowHint">
      <!-- 中间提示框 -->
      <div class="hint-detail">
        <span>{{ msgTitle }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { translate_Api } from "../../apis/tools.api";
export default {
  props: { chinese: String, english: String },
  data() {
    return {
      checked: 0,
      choice: false,
      isShowHint: false,
      msgTitle: "正在翻译中，请不要点击其他地方",
    };
  },
  methods: {
    getTranslate() {
      console.log(this.chinese, this.english);
      if (this.choice == false) {
        this.chinese = this.chinese.replace(/\&nbsp;|\&quot;|\&#39;/g, "");
      } else {
        this.english = this.english.replace(/\&nbsp;|\&quot;|\&#39;/g, "");
      }
      this.msgTitle = "正在翻译中，请不要点击其他地方";
      this.isShowHint = true;
      translate_Api({
        html_text: this.choice ? this.english : this.chinese,
        language_flag: this.choice ? 2 : 1,
        check_flag: this.checked,
      })
        .then((res) => {
          if (res.data == "无") {
            this.msgTitle = "请选择正确的中译英或者英译中";
            setTimeout(() => {
              this.isShowHint = false;
            }, 3000);
          } else {
            if (res.data != "") {
              this.$emit("returnTranslate", res.data, this.choice ? 2 : 1);
              this.isShowHint = false;
            } else {
              this.msgTitle = "出现异常了";
            }
          }
        })
        .catch((err) => {
          this.msgTitle = "出现异常了";
          setTimeout(() => {
            this.isShowHint = false;
          }, 2000);
        });
    },
    choiceType() {
      this.choice = !this.choice;
    },
  },
};
</script>
<style lang="scss" scoped>
.editTranslate {
  width: 120px;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  margin: auto;
  margin-right: 0px;
  margin-top: 20px;
  position: relative;
  .check-box {
    position: absolute;
    top: 5px;
    left: -130px;
  }
  .el-icon-sort-down {
    position: absolute;
    right: 100px;
    top: 1px;
    font-size: 30px;
    border-radius: 4px;
    color: $border-color;
    cursor: pointer;
  }
  .el-icon-sort-up {
    position: absolute;
    color: $border-color;
    border-radius: 4px;
    right: 85px;
    top: 0;
    font-size: 30px;
    cursor: pointer;
  }
  .blue {
    color: $blueBtna;
  }
  > span {
    background: $blueBtna;
    cursor: pointer;
    padding: 6px 15px 5px 17px;
    color: $base-color;
    font-size: 16px;
    border-radius: 15px;
  }
  .hint {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    .hint-detail {
      display: flex;
      justify-content: center;
      align-self: center;
      cursor: pointer;
      background: $base-color;
      width: 30%;
      height: 200px;
      border-radius: 6px;
      span {
        align-self: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/TranslateText.vue